import { UnknownAction } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "./index";
import { getFreshToken } from "./auth-actions";
import { EventsActions } from "./events-slice";
import { UIActions } from "./ui-slice";
import { t } from "../i18n";

export const DATABASE_URL =
  "https://react-auth-13b94-default-rtdb.europe-west1.firebasedatabase.app";

// Every way out of the add/edit form goes through here, so an edit that hasn't
// been saved gets the same warning whichever one the user took.
export const leaveEventForm = (next: UnknownAction) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    if (getState().ui.isFormDirty) {
      dispatch(UIActions.confirmLeaveForm(next));
    } else {
      dispatch(next);
    }
  };
};

export const fetchEventsData = (
  uid: string | null,
  background = false
) => {
  return async (dispatch: AppDispatch) => {
    // A background sync shows an unobtrusive banner; only a user-initiated
    // load gets the blocking loading modal.
    dispatch(
      background
        ? UIActions.refreshStart()
        : UIActions.loading({
            message: t.loading,
          })
    );
    const fetchData = async () => {
      const request = async (forceNewToken = false) => {
        const token = await dispatch(getFreshToken(forceNewToken));
        return fetch(
          DATABASE_URL +
            "/tasks/" +
            uid +
            ".json?auth=" +
            token +
            '&orderBy="deleted"&equalTo=false'
        );
      };

      let response = await request();
      if (response.status === 401) {
        response = await request(true);
      }

      if (!response.ok) {
        throw new Error(t.somethingWentWrong);
      }

      const data = await response.json();

      return data;
    };

    try {
      const eventsData = await fetchData();
      let loadedEvents = [];
      for (let key in eventsData) {
        loadedEvents.push({
          id: key,
          date: eventsData[key].date,
          title: eventsData[key].title,
          timeFrom: eventsData[key].timeFrom,
          timeTill: eventsData[key].timeTill,
          important: eventsData[key].important,
          reminder: eventsData[key].reminder,
          isBirthday: eventsData[key].isBirthday,
          repeat: eventsData[key].repeat,
          description: eventsData[key].description,
          deleted: eventsData[key].deleted,
        });
      }
      dispatch(
        EventsActions.fetch({
          events: loadedEvents,
        })
      );
      dispatch(background ? UIActions.refreshEnd() : UIActions.hide());
    } catch (err: any) {
      if (background) {
        // A failed background sync stays silent - the user didn't ask for it,
        // and the next tick will try again.
        dispatch(UIActions.refreshEnd());
        return;
      }
      dispatch(
        UIActions.error({
          message: err.message || t.somethingWentWrong,
        })
      );
    }
  };
};
